export default __webpack_public_path__ + "static/media/microsoft-sm.dbe849f6.svg";